import { html } from 'lit';
import { registerSiteWorkspaceModule } from '../../pages/app-members/workspace/site-workspace-modules.js';
import { terms } from '../../language/terms';

// Auto-register the Glass.Auditor domain module when this file is imported.
// This module will appear in the site workspace for sites with the Glass.Auditor domain.
// It allows system tenant admins to manage which glass processor sites the auditor can audit.

registerSiteWorkspaceModule({
  id: 'domain-glass-auditor',
  label: `Glass ${terms.auditor.value}`,
  icon: 'shield-check',
  order: 52, // After glass-dataentry (51)
  section: 'Configuration',
  domains: ['Glass.Auditor'], // Only visible to sites with this domain
  async load() {
    // Lazy-load the main component
    await import('./glass-auditor-workspace.js');
  },
  render: (context) => {
    return html`
      <glass-auditor-workspace
        .site=${context.site}
        .domains=${context.domains}
      ></glass-auditor-workspace>
    `;
  },
});
